import { type Static, Type } from '@sinclair/typebox';
import { MongoIdStringSchema } from '../dto/common.dto.js';
import { ItemUserPodcastDTOSchema } from '../dto/item-user.dto.js';

export const MarkAsListenedBodySchema = Type.Object({
  channelId: MongoIdStringSchema,
  itemId: MongoIdStringSchema,
  listened: Type.Boolean(),
});
export type MarkAsListenedBody = Static<typeof MarkAsListenedBodySchema>;

export const MarkAsListenedReplySchema = ItemUserPodcastDTOSchema;
export type MarkAsListenedReply = Static<typeof MarkAsListenedReplySchema>;

// ---------------------------------------------------------------------------------------------------------------------

export const TrackBodySchema = Type.Object({
  channelId: MongoIdStringSchema,
  itemId: MongoIdStringSchema,
  segments: Type.Array(Type.Tuple([Type.Number(), Type.Number()])),
  duration: Type.Number({ minimum: 1 }),
  position: Type.Number(),
});
export type TrackBody = Static<typeof TrackBodySchema>;

export const TrackReplySchema = ItemUserPodcastDTOSchema;
export type TrackReply = Static<typeof TrackReplySchema>;
